import {getAllVendors} from '../../services/VendorServices'

export function getProductGroupChildren(accountsGroupingList) {
    const list = accountsGroupingList || [];
    const productGroup = list.find(obj => obj.entity_name === 'PRODUCT' && Number(obj.system_field) === 1)
        || list.find(obj => obj.entity_name === 'PRODUCT');
    if (!productGroup) {
        return [];
    }
    const productId = Number(productGroup.id);
    return list.filter(item => Number(item.parent_id ?? item.parent?.id) === productId);
}

export function checkForDuplicateVendors(vendorName, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllVendors(cookies)
      .then((data) => {

        let isUserExists = false;
        data.vendor_list.forEach(vendor =>{
          if((vendor.entity_name) === vendorName.trim().toUpperCase()
          && parseInt(existingId)!== vendor.id){
            console.log(`Vendor exists with the name - ${vendorName}`) 
            isUserExists = true;
            
          }
        });
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }